import { render, staticRenderFns } from "./LatestDeals.vue?vue&type=template&id=be336c9c&"
import script from "./LatestDeals.vue?vue&type=script&lang=js&"
export * from "./LatestDeals.vue?vue&type=script&lang=js&"
import style0 from "./LatestDeals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports